module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/logo2026_tokyo-d1ba0da36f44e283d3faac6268958edc.svg";